var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{attrs:{"path":"booking.addSavedPerson.label"},nativeOn:{"click":function($event){return _vm.$emit('click')}}},[_c('font-awesome-icon',{attrs:{"slot":"icon","icon":"user"},slot:"icon"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }